import { render, staticRenderFns } from "./LogDetalhes.vue?vue&type=template&id=dbc6996c"
import script from "./LogDetalhes.vue?vue&type=script&lang=js"
export * from "./LogDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports